(() => {
  'use strict';
  if (!document.body.classList.contains('alp-mystery-page')) return;
  const variantInputs = () => Array.from(document.querySelectorAll('options-selection input[data-variant-option-value]'));
  const enhanceOptions = () => {
    document.querySelectorAll('.product-breadcrumb a[href$="/collections/all"]').forEach(link => {
      if (link.textContent.trim() === 'All') link.textContent = 'Perfumes';
    });
    document.querySelectorAll('.product_form input[name="quantity"]').forEach(input => input.setAttribute('aria-label', 'Cantidad'));
    document.querySelectorAll('.product_form [data-update-quantity]').forEach(control => {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-label', control.dataset.updateQuantity === 'plus' ? 'Aumentar cantidad' : 'Disminuir cantidad');
      if (control.dataset.mbxQuantityReady) return;
      control.dataset.mbxQuantityReady = 'true';
      const updateDisabled = () => control.setAttribute('aria-disabled', String(control.hasAttribute('disabled')));
      updateDisabled();
      new MutationObserver(updateDisabled).observe(control, {attributes: true, attributeFilter: ['disabled']});
      control.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (!control.hasAttribute('disabled')) control.click();
      });
    });
    const data = document.querySelector('[data-mbx-variant-data]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    variants.forEach(variant => {
      const input = variantInputs().find(option => option.value === variant.option);
      if (!input) return;
      const label = Array.from(input.closest('fieldset').querySelectorAll('label')).find(item => item.htmlFor === input.id);
      if (!label || label.querySelector('.mbx-option-price')) return;
      [['mbx-option-price', variant.price], ['mbx-option-description', variant.description]].forEach(([name, text]) => {
        const span = document.createElement('span');
        span.className = name;
        span.textContent = text;
        label.appendChild(span);
      });
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-mbx-variant]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const input = variantInputs().find(option => option.value === link.dataset.mbxVariant && !option.disabled);
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    input.click();
    const focusTarget = input.closest('.swatch__option').querySelector('.swatch-element') || input;
    focusTarget.focus({preventScroll: true});
    input.closest('fieldset').scrollIntoView({block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceOptions, {once: true});
  else enhanceOptions();
  document.addEventListener('shopify:section:load', enhanceOptions);
})();
